var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconocamaraDorado(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 27,
    viewBox: "0 0 30 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_material-photo-camera",
    "data-name": "Icon material-photo-camera",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_769",
    "data-name": "Trazado 769",
    d: "M22.8,18A4.8,4.8,0,1,1,18,13.2,4.8,4.8,0,0,1,22.8,18Z",
    fill: "#b2a169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_770",
    "data-name": "Trazado 770",
    d: "M13.5,3,10.755,6H6A3.009,3.009,0,0,0,3,9V27a3.009,3.009,0,0,0,3,3H30a3.009,3.009,0,0,0,3-3V9a3.009,3.009,0,0,0-3-3H25.245L22.5,3ZM18,25.5A7.5,7.5,0,1,1,25.5,18,7.5,7.5,0,0,1,18,25.5Z",
    fill: "#b2a169"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconocamaraDorado);
export default __webpack_public_path__ + "static/media/Icono camara - dorado.6dd440d6f4532fbcba01b41db1d84326.svg";
export { ForwardRef as ReactComponent };